import { buildTaskAssigneePayload, resolveTaskAssigneeIds, type TaskAssigneeOption } from '~/lib/taskAssignees';
import type { Task } from '~/types/models';

export type TaskQuickCreateDraft = Partial<Task> & { title: string };

export function createTaskQuickDraft(initial: Partial<Task> = {}, defaultStatus = 'Todo'): TaskQuickCreateDraft {
    return {
        ...initial,
        title: String(initial.title || ''),
        status: initial.status || defaultStatus,
        priority: initial.priority || 'medium',
    };
}

export function canQuickCreateTask(draft: TaskQuickCreateDraft): boolean {
    return Boolean(draft.title.trim());
}

export function buildQuickTaskPayload(
    draft: TaskQuickCreateDraft,
    assigneeOptions: TaskAssigneeOption[] = [],
): Omit<Task, 'id' | 'createdAt' | 'updatedAt'> {
    const { id: _id, createdAt: _createdAt, updatedAt: _updatedAt, ...draftPayload } = draft;
    const assignees = buildTaskAssigneePayload(resolveTaskAssigneeIds(draft), assigneeOptions);

    return {
        ...draftPayload,
        ...assignees,
        title: draft.title.trim(),
        description: String(draft.description || '').trim() || undefined,
        projectId: draft.projectId || undefined,
        milestoneId: draft.projectId && draft.milestoneId ? draft.milestoneId : undefined,
        clientId: draft.clientId || undefined,
        dueDate: draft.dueDate || undefined,
        startDate: draft.startDate || undefined,
        endDate: draft.endDate || undefined,
    };
}
